import { FieldProps, getIn } from 'formik';
import React from 'react';
import DatePicker, { IDatePickerProps, IDateTimePickerProps, DateTimePicker } from '../DatePicker';
import Select, { SelectRefactor } from '../OldSelect';
import { ISelectProps, ISelectRefactorProps } from '../OldSelect/interfaces';
import TextField, { ITextFieldProps } from '../TextField';

interface TextFieldComponent extends FieldProps, ITextFieldProps {
  onChangeForce?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

interface SelectComponent extends FieldProps, ISelectProps {}

interface DatePickerComponent extends FieldProps, IDatePickerProps {}

interface DateTimePickerComponent extends FieldProps, IDateTimePickerProps {}

interface ISelectRefactorComponent extends FieldProps, ISelectRefactorProps {}

const getError = (field: any, form: any, optionDefaultLabel: any = null) => {
  const error = getIn(form.errors, field!.name);
  const hasError = !!error && !!getIn(form.touched, field!.name);
  let helperText = null;

  if (hasError) {
    helperText = typeof error === 'string' ? error : error[optionDefaultLabel || 'label'];
  }

  return {
    error: hasError,
    helperText,
  };
};

export const FormikTextFieldComponent: React.FC<TextFieldComponent> = (props) => {
  const { field, form, onChangeForce, ...rest } = props;

  return <TextField {...rest} {...field} onChange={onChangeForce || field.onChange} {...getError(field, form)} />;
};

export const FormikSelectComponent: React.FC<SelectComponent> = ({
  field: { onChange, ...fieldRest },
  form,
  ...rest
}) => {
  return <Select {...rest} {...fieldRest} {...getError(fieldRest, form)} />;
};

export const FormikSelectRefactorComponent: React.FC<ISelectRefactorComponent> = ({
  field: { onChange, ...fieldRest },
  form,
  ...rest
}) => {
  return <SelectRefactor {...rest} {...fieldRest} {...getError(fieldRest, form, rest.optionDefaultLabel)} />;
};

export const FormikDatePickerComponent: React.FC<DatePickerComponent> = ({
  field: { onChange, ...fieldRest },
  form,
  ...rest
}) => {
  return <DatePicker {...rest} {...fieldRest} {...getError(fieldRest, form)} />;
};

export const FormikDateTimePickerComponent: React.FC<DateTimePickerComponent> = ({
  field: { onChange, ...fieldRest },
  form,
  ...rest
}) => {
  return <DateTimePicker {...rest} {...fieldRest} {...getError(fieldRest, form)} />;
};
